import React, { useEffect, useState } from "react";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import "./ManualOperacoes.css";

const PortifolioPerfumaria = () => {
  const [menuClose, setMenuClose] = useState(false);
  const [portfolioUrl, setPortfolioUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const toggleMenu = () => {
    setMenuClose((prev) => !prev);
  };

  useEffect(() => {
    let mounted = true;

    const loadPortfolio = async () => {
      try {
        setLoading(true);
        const response = await Api.get("/public/perfumery-portfolio");
        const nextUrl = String(response?.data?.settings?.embedUrl || "").trim();

        if (!mounted) return;
        setPortfolioUrl(nextUrl);
      } catch (err) {
        console.error("Erro ao carregar portifolio de perfumaria:", err);

        if (!mounted) return;
        setPortfolioUrl("");
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadPortfolio();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="app-container">
      <Sidebar close={menuClose} portifolioPerfumariaActive="active" />

      <main className="main-content">
        <Topbar page="Portifolio de perfumaria" onToggleMenu={toggleMenu} />

        <section className="manual-card">
          <div className="manual-card-header">
            <div>
              <h1 className="manual-card-title">Portifolio de perfumaria</h1>
              <p className="manual-card-description">
                Consulte o portifolio de perfumaria diretamente no sistema, em formato revista.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="manual-empty-state">Carregando portifolio de perfumaria...</div>
          ) : portfolioUrl ? (
            <div className="manual-frame-wrapper">
              <iframe
                className="manual-frame"
                src={portfolioUrl}
                title="Portifolio de perfumaria"
                scrolling="no"
                frameBorder="0"
                allowTransparency
                allowFullScreen
              />
            </div>
          ) : (
            <div className="manual-empty-state">
              Nenhum portifolio configurado no momento. Procure o super administrador.
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default PortifolioPerfumaria;
